class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 1000);

		// console.log('FacetFiltersForm',this);
		if( this.querySelector('[data-mobile-facets-view-results-btn]')){
			this.querySelector('[data-mobile-facets-view-results-btn]').addEventListener('click',this.onSubmitHandler.bind(this));
		}else{
			this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
		}

		const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
		if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		}
		window.addEventListener('popstate', onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll('.js-facet-remove').forEach((element) => {
			element.classList.toggle('disabled', disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById('ProductCount');
		const countContainerDesktop = document.getElementById('ProductCountDesktop');
		document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
		if (countContainer){
			countContainer.classList.add('loading');
		}
		if (countContainerDesktop){
			countContainerDesktop.classList.add('loading');
		}

		// sections.forEach((section) => {
		// 	const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
		// 	const filterDataUrl = element => element.url === url;
		//
		// 	// FacetFiltersForm.filterData.some(filterDataUrl) ?
		// 	// 	FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, searchParams) :
		// 		FacetFiltersForm.renderSectionFromFetch(url, event, searchParams);
		// });


		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
		location.reload()
	}

	static renderSectionFromFetch(url, event, searchParams) {
		const loader = document.querySelector('.collection-with-fixed-filtering .loader');
		//loader.style.display = 'flex';
		fetch(url)
			.then(response => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
				FacetFiltersForm.renderFilters(html, event);
				//FacetFiltersForm.renderProductGridContainer(html);
				// FacetFiltersForm.renderProductCount(html);
				// FacetFiltersForm.fixShopify(searchParams);
				//important reload addition to make all other apps code accessable
				//var intFrameWidth = window.innerWidth;
				// if (intFrameWidth >= 750){

				location.reload()
				//}

			});
	}

	static renderSectionFromCache(filterDataUrl, event, searchParams) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		//FacetFiltersForm.renderFilters(html, event);
		//FacetFiltersForm.renderProductGridContainer(html);
		//FacetFiltersForm.renderProductCount(html);
		// FacetFiltersForm.fixShopify(searchParams);
	}




	static renderProductGridContainer(html) {
		// document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
	}

	static renderProductCount(html) {
		const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
		const container = document.getElementById('ProductCount');
		const containerDesktop = document.getElementById('ProductCountDesktop');
		container.innerHTML = count;
		container.classList.remove('loading');
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove('loading');
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

		const facetDetailsElements =
			parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest('.js-filter') : undefined;
			return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
		}
		const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

		var js_buttons = document.querySelectorAll('.js-button__slide-filter');
		for (let i = 0; i < js_buttons.length; i++) {
			if (js_buttons[i].getAttribute('listener') !== 'true') {
				js_buttons[i].addEventListener('click', () => {
					js_buttons[i].parentNode.toggleAttribute('open');
					js_buttons[i].setAttribute('listener', 'true');
				});
			}
		}
		document.querySelector('.custom-select-wrapper').addEventListener('click', function() {
			this.querySelector('.custom-select').classList.toggle('open');
		})
		for (const option of document.querySelectorAll(".custom-option")) {
			option.addEventListener('click', function(event) {
				if (!this.classList.contains('selected')) {
					this.parentNode.querySelector('.custom-option.selected').classList.remove('selected');
					this.classList.add('selected');
					this.closest('.custom-select').querySelector('.custom-select__trigger span').textContent = this.textContent;

					const select = document.querySelector('.facet-filters__sort--steering');
					select.value = this.dataset.value;

					const d = document.querySelector('facet-filters-form')
					d.onSubmitHandler(event)
				}
			})
		}
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
		})

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
		});

		document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector('.facets__selected');
		const sourceElement = source.querySelector('.facets__selected');

		if (sourceElement && targetElement) {
			target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
	}

	static getSections() {
		return [
			{
				section: document.getElementById('product-grid').dataset.id,
			}
		]
	}

	onSubmitHandler(event) {
		event.preventDefault();
		// orig
		// const formData = new FormData(event.target.closest('form'));

		// getting data from respective forms (due to them being separate)
		let sort_form;
		let filter_form;
		// const sort_forms = document.querySelectorAll('form.js-form__sorts');
		// const filter_forms = document.querySelectorAll('form.js-form__filters');
		//console.log('sort_form');
		// const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
		// if (isMobile) {
		// 	sort_form = sort_forms[1];
		// 	filter_form = filter_forms[1];
		// } else {
		// 	sort_form = sort_forms[0];
		// 	filter_form = filter_forms[0];
		// }

		if( event.target.closest('form').classList.contains('mobile-facets')){
			sort_form = document.querySelector('form.js-form__sorts.mobile-facets');
			filter_form = document.querySelector('form.js-form__filters.mobile-facets');
		}else{
			sort_form = document.querySelector('form.js-form__sorts.desktop-facets');
			filter_form = document.querySelector('form.js-form__filters.desktop-facets');
		}

		/*sort_forms.forEach(form => {
		  if (form.offsetWidth !== 0) sort_form = form;
	  })

	  filter_forms.forEach(form => {
		  console.log('offset width');
		  console.log(form.className);
		  if (form.offsetWidth !== 0) filter_form = form;
	  })
	  */
		/* console.log("sort form");
		 console.log(sort_forms);
		 console.log("filter form");
		 console.log(filter_forms);*/
		const formData_sorts = new FormData(sort_form);
		const formData_filters = new FormData(filter_form);

		// orig
		// const searchParams = new URLSearchParams(formData).toString();

		// getting data from those forms
		let searchParams_sorts = new URLSearchParams(formData_sorts).toString();
		let searchParams_filters = new URLSearchParams(formData_filters).toString();

		// checking for params and joining them together depending if they are empty or not
		let searchParams = "";
		if (searchParams_sorts === "") {
			searchParams_sorts = 'sort_by=price-ascending';
		}
		if(searchParams_sorts !== "" && searchParams_filters !== "") {
			searchParams = `${searchParams_sorts}&${searchParams_filters}`
		} else if(searchParams_sorts !== "" && searchParams_filters === "") {
			searchParams = searchParams_sorts;
		} else if(searchParams_sorts === "" && searchParams_filters !== "") {
			searchParams = searchParams_filters;
		}
		/* console.log('debugging sort');
		 console.log(new URLSearchParams(formData_filters));
		console.log(searchParams_sorts);
		console.log(searchParams_filters);
		console.log(searchParams);
		 console.log('finished debugging sort');*/
		// continuing normal operation
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
		FacetFiltersForm.renderPage(url);
	}

	static fixShopify(searchParams) {
		// when filter is active on reload/load if page
		/* const filter = document.querySelector('facet-filters-form .js-form__filters');
		 const product_grid = document.querySelector('#product-grid');
		 const loadMore = document.querySelector('.load-more_wrap');

		 if(searchParams.includes('filter') === true && window.innerWidth >= 750) {
		  const w = document.querySelector('#product-grid .grid__item').offsetWidth;
		   //console.log(w);
		   filter.setAttribute('open','');
		   product_grid.setAttribute('filters-open','');

		   filter.style.width = `${w}px`;

		   product_grid.style.width = `${product_grid.offsetWidth - w - 30}px`;
		   product_grid.style.marginLeft = 'auto';
		   product_grid.style.marginRight = '0';
		   if (loadMore) {
			 loadMore.style.width = `${loadMore.offsetWidth - w - 30}px`;
			 loadMore.style.marginLeft = 'auto';
			 loadMore.style.marginRight = '0';
		   }
		 } else {
		   filter.removeAttribute('open');
		   product_grid.removeAttribute('filters-open');
		 } */
		// ---
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll('input')
		    .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll('input');
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute('max', maxInput.value);
		if (minInput.value) maxInput.setAttribute('min', minInput.value);
		if (minInput.value === '') maxInput.setAttribute('min', 0);
		if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute('min'));
		const max = Number(input.getAttribute('max'));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		this.querySelector('a').addEventListener('click', (event) => {
			event.preventDefault();
			const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
			form.onActiveFilterClick(event);
		});
	}
}

customElements.define('facet-remove', FacetRemove);
